<footer class="footer has-background-black has-text-white">
    <div class="container">
        <div class="columns">
            <!-- Első oszlop: Cég információ -->
            <div class="column">
                <a routerLink="/">
                    <img src="assets/logo.svg" width="150px" alt="Logo" />
                </a>
                <p>{{ 'footer.address' | translate }}</p>
                <p>{{ 'footer.email' | translate}}</p>
                <p>{{ 'footer.phone' | translate }}</p>
            </div>

            <!-- Második oszlop: Menüpontok 
            <div class="column">
                <h3 class="title is-5">Navigáció</h3>
                <ul>
                    <li><a routerLink="/" class="has-text-white">Főoldal</a></li>
                    <li><a routerLink="/about" class="has-text-white">Rólunk</a></li>
                    <li><a routerLink="/contact" class="has-text-white">Elérhetőségek</a></li>
                </ul>
            </div>
            -->

            <!-- Harmadik oszlop: Közösségi média -->
            <div class="column">
                <h3 class="title is-5">{{ 'footer.follow-us' | translate }}</h3>
                <div class="social-media">
                    <a href="https://facebook.com/twogetherflowers" target="_blank" alt="D&D Twogether - Flowers and More facebook oldala">
                        <img src="assets/facebook-icon.svg" width="30px" height="30px" alt="Facebook">
                    </a>
                    <a href="https://instagram.com/twogetherflowers" target="_blank" alt="D&D Twogether - Flowers and More Instagram oldala">
                        <img src="assets/instagram-white-icon.svg" width="30px" height="30px" alt="instagram logó" />
                    </a>
                    <a href="https://www.tiktok.com/@twogetherflower" target="_blank" alt="D&D Twogether - Flowers and More TikTok oldala">
                        <img src="assets/tiktok-icon.svg" width="30px" height="30px" alt="TikTok">
                    </a>
                </div>
            </div>
        </div>
    </div>
</footer>